const AuthConstants = require('./constants');

module.exports = {
    POLICY: AuthConstants.policy,
    normalizeEmail,
    isNearpeerInternalEmail,
    isNearpeerInternalUser
};

function normalizeEmail(email) {

    if (typeof email !== 'string') {
        return null;
    }

    return email.trim().toLowerCase() || null;
}

function isNearpeerInternalEmail(email) {

    const normalizedEmail = normalizeEmail(email);

    if (!normalizedEmail) {
        return false;
    }

    return AuthConstants.policy.nearpeerInternalEmailDomains.some((domain) => (
        normalizedEmail.endsWith(`@${domain}`)
    ));
}

function isNearpeerInternalUser(user = {}) {

    return isNearpeerInternalEmail(user.email || user.profileEmail || user.authEmail);
}
